import React, { useEffect, useState } from 'react';

import { Button, Modal } from '@getethos/ethos-design-system-v2';
import { apiEndPoints } from '../../common/api.endPoints';
import { Body, FlexCol, FlexRow, Spacer } from '../../common/components/v2';
import { Resource } from '../../common/constants/resource';
import { HttpService } from '../../common/http.service';
import styles from './styles.module.scss';

export const TncModal = ({
  onAccepted,
}: {
  onAccepted: (error?: Error) => void;
}) => {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (!accepted) return;

    const acceptTermsAndConditions = async () => {
      try {
        const endpoint = apiEndPoints.acceptTnc;

        if (!endpoint) {
          throw new Error('API endpoint for accepting TnC is undefined');
        }

        const response = await HttpService.getInstance().post(endpoint, {});

        if (response && !response.error) {
          onAccepted();
        } else {
          onAccepted(response?.error || new Error('Unknown error'));
        }
      } catch (error) {
        if (error instanceof Error) {
          onAccepted(error);
        } else {
          onAccepted(new Error('An unknown error occurred'));
        }
      }
    };

    acceptTermsAndConditions();
  }, [accepted]);

  // tslint:disable-next-line:no-empty
  const noop = () => {};

  return (
    <Modal open title={Resource.TNC_TITLE} onClose={noop}>
      <FlexCol className={styles.SmallModal}>
        <Body>
          {Resource.TNC_BODY_1}
          <a href={Resource.TNC_URL} target="_blank">
            {Resource.TNC_URL_TEXT}
          </a>
          {Resource.TNC_BODY_2}
        </Body>
        <Spacer height={32} />
        <FlexRow>
          <Button
            size="md"
            variant="warningOutline"
            buttonTitle={Resource.TNC_BUTTON}
            onClick={() => {
              console.log('Accepting terms of use');
              setAccepted(true);
            }}
          ></Button>
        </FlexRow>
      </FlexCol>
    </Modal>
  );
};
